import { ApiUrl } from 'src/constants';
import { httpService } from 'src/services';

export function postBookNowForm(data: any) {
  return httpService.post(`${ApiUrl.getApiUrl().bookNowForm}`, data, {});
}
